<template>
  <div class="plan--sku-container">
    <div class="mb-4">
      <SkuTable :evgPlanOrderCode="evgPlanOrderCode"></SkuTable>
    </div>
    <div class="mb-4">
      <SkuSpecTable :evgPlanOrderCode="evgPlanOrderCode"></SkuSpecTable>
    </div>
    <div>
      <SkuFabricTable :evgPlanOrderCode="evgPlanOrderCode"></SkuFabricTable>
    </div>
  </div>
</template>
<script>
import SkuTable from './sku-table'
import SkuSpecTable from './sku-spec-table'
import SkuFabricTable from './sku-fabric-table'
export default {
  props: {
    evgPlanOrderCode: { type: String, default: '' },
  },
  components: { SkuTable, SkuSpecTable, SkuFabricTable },
}
</script>
<style lang="scss" scoped></style>
